import { defineElement, FC, onDidLoad, useElement, useListen, useProp } from '@atomify/hooks';
import { addToWishlist, removeFromWishlist, userStore, wishlistContains } from '@store/user';

const IS_ADDED_PROP = 'is-added';
const IS_NOT_ADDED_PROP = 'is-not-added';

const BPDWishlistToggle: FC = ({ element }) => {
    const cnID = window.__ENVIRONMENT_DETAILS__.wishlistConstructionNumberId || '';
    const [constructionNumberId] = useProp<string>('constructionNumberId', cnID);
    const button = useElement<HTMLButtonElement>('button');

    useListen(button, 'click', handleClick);
    async function handleClick(e: Event) {
        e.stopPropagation();
        e.preventDefault();

        button.current?.classList.add('is-loading');
        if (wishlistContains(constructionNumberId)) {
            removeFromWishlist(constructionNumberId);
        } else {
            await addToWishlist(constructionNumberId);
        }
        button.current?.classList.remove('is-loading');
    }

    onDidLoad(() => {
        setProps();

        userStore.subscribe(() => setProps(), ['wishlist']);
    });

    function setProps() {
        if (wishlistContains(constructionNumberId)) {
            element.setAttribute(IS_ADDED_PROP, '');
            element.removeAttribute(IS_NOT_ADDED_PROP);
        } else {
            element.setAttribute(IS_NOT_ADDED_PROP, '');
            element.removeAttribute(IS_ADDED_PROP);
        }
    }
};

BPDWishlistToggle.props = {
    constructionNumberId: { type: String },
};

defineElement('bpd-wishlist-toggle-wrapper', BPDWishlistToggle);
